<template>
  <div
    class="square"
    :class="{ enabled }"
  />
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Square',
  props: {
    enabled: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style scoped>
  .square {
    width: 8px;
    height: 8px;
    border: 1px black solid;
  }

  .enabled {
    background-color: darkslategray;
  }
</style>
